import {Typography} from "../styles/typography";
import {Button} from "../components/button";
import {Hero} from "../components/Hero";
import * as React from "react";
import {Body} from "../components/Body";
import {Spacing} from "../styles/spacing";
import {StaticImage} from "gatsby-plugin-image";
import {Section} from "../components/content";
import {DESKTOP_MIN_WIDTH, MOBILE_MAX_WIDTH} from "../styles/utils";
import {css} from "@emotion/react";
import Seo from "../components/Seo";
import {DesktopBr} from "../components/utils";
import {SiteLink} from "../components/SiteLink";

const ImageStyle = css`
  @media (min-width: ${DESKTOP_MIN_WIDTH}) {
    :nth-child(3n+3) {
      margin-bottom: 24px;
    }
  }
  @media (max-width: ${MOBILE_MAX_WIDTH}) {
    margin-bottom: 24px;
  }
`

const PressKitPage = () => {
  return <Body safe={false}>
    <Seo title={'Press Kit'}/>

    <Hero
      title={<>Rimaniamo in contatto</>}
      subtitle={<>Contattaci a info@tate.it per informazioni stampa, richieste media<DesktopBr/> o scarica il nostro
        press kit per logo e foto</>}
    >
      <SiteLink
        to={'https://drive.google.com/drive/folders/11ISsiY9CYZ9Pe8LDJwKigRbBB_fFCGty'}
        target={'_blank'}
        rel={'noreferrer nofollow'}
        name={'Scaricalo'}>
        <Button limit={'true'} variant="primary" css={[Spacing.Margin.top_24]}>
          <span css={[Typography.heading.h6_600]}>Scaricalo</span>
        </Button>
      </SiteLink>
    </Hero>

    <Section className="row">
      <div className="row">
        <div className="col-12 col-sm-4" css={ImageStyle}>
          <StaticImage src={"../images/pages/press-kit/brand_guidelines_1.jpg"} alt={''} width={500}/>
        </div>
        <div className="col-12 col-sm-4" css={ImageStyle}>
          <StaticImage src={"../images/pages/press-kit/brand_guidelines_2.jpg"} alt={''} width={500}/>
        </div>
        <div className="col-12 col-sm-4" css={ImageStyle}>
          <StaticImage src={"../images/pages/press-kit/brand_guidelines_3.jpg"} alt={''} width={500}/>
        </div>
        <div className="col-12 col-sm-4" css={ImageStyle}>
          <StaticImage src={"../images/pages/press-kit/brand_guidelines_4.jpg"} alt={''} width={500}/>
        </div>
        <div className="col-12 col-sm-4" css={ImageStyle}>
          <StaticImage src={"../images/pages/press-kit/brand_guidelines_5.jpg"} alt={''} width={500}/>
        </div>
        <div className="col-12 col-sm-4" css={ImageStyle}>
          <StaticImage src={"../images/pages/press-kit/brand_guidelines_6.jpg"} alt={''} width={500}/>
        </div>
      </div>
    </Section>
  </Body>
}

export default PressKitPage
